const MGA_TO_FMG = 5;
const MGA_TO_EUR = 0.00020;
const MGA_TO_USD = 0.00022;

export const CURRENCY_OPTIONS = {
  fmg: { label: 'FMG', symbol: '○' },
  eur: { label: 'EUR', symbol: '€' },
  usd: { label: 'USD', symbol: '$' },
};

// Use regular space (U+0020) as thousands separator for copy/paste consistency
// with admin form inputs (NumberInput component). Browser Intl APIs return a
// narrow no-break space (U+202F) under fr-* locales, so we normalise.
const SPACE_RE = /\u202F|\u00A0/g;

const formatIntFr = (n) =>
  new Intl.NumberFormat('fr-FR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .format(n)
    .replace(SPACE_RE, ' ');

export const formatMGA = (amount) => `${formatIntFr(amount)} Ar`;

const formatSecondary = (mgaAmount, currency) => {
  switch (currency) {
    case 'eur': {
      const val = Math.round(mgaAmount * MGA_TO_EUR);
      return '≈ ' + formatIntFr(val) + ' €';
    }
    case 'usd': {
      const val = Math.round(mgaAmount * MGA_TO_USD);
      return '≈ ' + formatIntFr(val) + ' $';
    }
    default: {
      const val = mgaAmount * MGA_TO_FMG;
      return '≈ ' + formatIntFr(val) + ' FMG';
    }
  }
};

export const formatDualCurrency = (mgaAmount, secondaryCurrency = 'fmg') => {
  return {
    mga: formatMGA(mgaAmount),
    fmg: formatSecondary(mgaAmount, secondaryCurrency),
  };
};
